import {Header} from "../List/BasicListDesign"
function Home(){

    return(
        <div id ="Wrapper">
        <Header>홈</Header>
        </div>
    );
}
export default Home;